import axios from 'axios';
import qs from 'qs';
import { API_URL } from '../../config';

// Función para obtener todos los usuarios por company_id
export const getAllUsers = async (company_id) => {
    const data = qs.stringify({
        'action': 'getAllUsers',
        'company_id': company_id
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para validar usuario
export const validateUser = async (email, password) => {
    const data = qs.stringify({
        'action': 'validateUser',
        'identifier': email,
        'password': password
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const userExists = async (identifier) => {
    const data = qs.stringify({
        'action': 'existsUser',
        'identifier': identifier
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error('Error al verificar si el usuario existe:', error);
        throw error;
    }
};

// Función para insertar una máquina
export const insertMachine = async (user, machineData, imageFile, pdfFile) => {
    let data = new FormData();
    data.append('action', 'insertMachine');
    data.append('id', user.Id_User);
    data.append('ref', machineData['ref'] || machineData['Referencia']);
    data.append('location', machineData['location'] || machineData['Ubicación']);
    data.append('name', machineData['name'] || machineData['Nombre']);
    data.append('internal_code', machineData['internal_code'] || machineData['Código Interno']);
    data.append('state', machineData['state'] || machineData['Estado']);
    data.append('inst_date', machineData['inst_date'] || machineData['Fecha de Instalación']);
    data.append('observation', machineData['observation'] || machineData['Observación'] || '');
    data.append('company_id', user.Id_Empresa);
    data.append('priority', machineData['priority'] || machineData['Prioridad']);


    if (imageFile) {
        data.append('imagen', imageFile);
    }
    if (pdfFile) {
        data.append('pdf', pdfFile);
    }

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para actualizar una o varias máquinas
export const updateMachine = async (user, machine) => {
    if (!Array.isArray(machine)) {
        machine = [machine];
    }
    const results = [];
    for (const m of machine) {
        const data = qs.stringify({
            'action': 'updateMachine',
            'id': user,
            'id_machine': m.Id_Machine,
            'ref': m.Ref_Machine,
            'location': m.Location_Machine,
            'name': m.Name_Machine,
            'internal_code': m.Internall_Code_Machine,
            'state': m.State_Machine,
            'inst_date': m.Inst_Date_Machine,
            'observation': m.Observation_Machine,
            'priority': m.Priority_Machine
        });

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: API_URL,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };

        try {
            const response = await axios.request(config);
            results.push({ data: response.data });
        } catch (error) {
            console.error(error);
            results.push({ error: 'Error al actualizar la máquina' });
        }
    }
    return results;
};
// Función para obtener máquinas por usuario
export const getMachines = async (id_user) => {
    const data = qs.stringify({
        'action': 'getMachines',
        'id': id_user
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para eliminar una o varias máquinas
export const deleteMachines = async (userId, selectedMachines) => {
    if (!Array.isArray(selectedMachines)) {
        selectedMachines = [selectedMachines];
    }
    let confirmDelete = false;
    if (selectedMachines.length > 0) {
        confirmDelete = window.confirm(`¿Está seguro de que desea borrar las siguientes máquinas: ${selectedMachines.map(machine => machine.Name_Machine).join(', ')}?`);
    } else {
        confirmDelete = false;
    }

    if (confirmDelete) {
        const results = [];
        for (const machine of selectedMachines) {
            const data = qs.stringify({
                'action': 'deleteMachine',
                'id': userId,
                'id_machine': machine.Id_Machine
            });

            const config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: API_URL,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
            };

            try {
                const response = await axios.request(config);
                results.push({ data: response.data });
            } catch (error) {
                console.error(error);
                results.push({ error: 'Error al borrar la máquina' });
            }
        }
        return results;
    } else {
        return { error: 'No se borraron máquinas' };
    }
};

// Función para generar órdenes de mantenimiento
export const getGenerateOrders = async (id_empresa) => {
    const data = qs.stringify({
        'action': 'generateMaintanceOrders',
        'id_empresa': id_empresa
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para obtener órdenes por compañía
export const getOrdersByCompany = async (id_empresa) => {
    const data = qs.stringify({
        'action': 'getOrdersByCompany',
        'id_empresa': id_empresa
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para actualizar una orden de trabajo
export const updateOrder = async (id_order, scheduled_date, assigned_user, priority, status, observation) => {
    const data = qs.stringify({
        'action': 'updateOrder',
        'id_order': id_order,
        'scheduled_date': scheduled_date,
        'assigned_user': assigned_user,
        'priority': priority,
        'status': status,
        'observation': observation
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const insertOrder = async (id_task, id_empresa, scheduled_date, assigned_user, priority, status) => {
    let data = qs.stringify({
        'action': 'insertOrder',
        'id_task': id_task,
        'id_empresa': id_empresa,
        'scheduled_date': scheduled_date,
        'assigned_user': assigned_user,
        'priority': priority,
        'status': status, 
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};


// Función para insertar una tarea
export const insertTask = async (taskData) => {
    const data = qs.stringify({
        'action': 'insertTask',
        ...taskData
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para actualizar una tarea
export const updateTask = async (taskId, taskData) => {
    const data = qs.stringify({
        'action': 'updateTask',
        'id_task': taskId,
        ...taskData
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para obtener tareas por máquina
export const getTasksByMachine = async (id_machine) => {
    const data = qs.stringify({
        'action': 'getTasksByMachine',
        'id_machine': id_machine
    });

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Función para eliminar una o varias tareas
export const deleteTasksByIds = async (tasks) => {
    const results = [];
    if (!Array.isArray(tasks)) {
        tasks = [tasks];
    }
    for (const task of tasks) {
        if (task.Id_Task_Type !== 6) {
            const data = qs.stringify({
                'action': 'deleteTask',
                'id_task': task.Id_Task
            });

            const config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: API_URL,
                headers: { 
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
            };

            try {
                const response = await axios.request(config);
                response.data.Task_code = task.Internal_Code; // Añadir el código de la tarea a la respuesta
                results.push(response.data); // Añadir el objeto actualizado al array results
            } catch (error) {
                console.error(error);
                results.push({ error: 'Error al borrar la tarea', Task_code: task.Internal_Code });
            }
        } else {
            results.push({ error: 'No se puede borrar una tarea de tipo "Correctivo"', Task_code: task.Internal_Code });
        }
    }
    return results;
};

export const getHistoriesByEmpresa = async (id_empresa) => {
    try {
        const data = qs.stringify({
            'action': 'getHistoriesByEmpresa',
            'id_empresa': id_empresa
        });

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url:  API_URL,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };

        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getCompanyById = async (id) => {
    const data = qs.stringify({
      'action': 'getCompanyById',
      'id': id
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: data
    };

    try {
      const response = await axios.request(config);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
};

export const enviarCorreo = async (destinatario, nombre, asunto, cuerpoHTML) => {
    const data = qs.stringify({
        'action': 'enviarCorreo',
        'destinatario': destinatario,
        'nombre': nombre,
        'asunto': asunto,
        'cuerpoHTML': cuerpoHTML
    });
    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URL,
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

